<template>
	<div class="container">
		<el-card>
			<div slot="header">人员管理</div>
			<div style="height: 100%">
				<div>
					<!-- <el-button type="primary" size="small" @click="downloadTemplate">下载模板</el-button>
					<el-button type="primary" size="small" @click="importExcelClick">批量导入</el-button> -->
					<el-button type="primary" @click="addMeter" icon="el-icon-plus" size="small"
						style="background-color: #1c84c6 !important">添加</el-button>
					<el-button type="primary" @click="editCardInfo" class="el-icon-edit" size="small"
						style="background-color: #1abc9c !important">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="deleteMeter"
						style="background-color: #ed5565 !important">删除</el-button>
					<el-button type="primary" class="iconfont icon-excel" size="small" @click="exportToExcel"
						style="background-color: #23c6c8 !important">导出</el-button>
					<el-button type="primary" @click="addRegion" icon="el-icon-plus" size="small"
						style="background-color: #1c84c6 !important">添加区域</el-button>
				</div>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<el-form-item label="姓名">
						<el-input v-model="queryParams.name" class="searchTag" clearable placeholder="姓名">
						</el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="queryParams.phone" class="searchTag" clearable placeholder="手机号">
						</el-input>
					</el-form-item>
					<el-form-item label="岗位">
						<el-select v-model="queryParams.workPosition" placeholder="" clearable class="searchTag"
							filterable>
							<el-option v-for="item in  workPositionOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableBox">
					<div class="tableStyle">
						<el-table :data="tableData" ref="nbCardInfoTable" style="width: 100%" height="90%"
							v-loading="loading" id="nbRecordTable" highlight-current-row
							@current-change="handleCurrentChange">
							<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
							</el-table-column>
							<el-table-column prop="name" label="姓名" width="" align="center">
							</el-table-column>
							<el-table-column prop="phone" label="手机号" align="center">
							</el-table-column>
							<el-table-column prop="workPosition" label="岗位" align="center">
							</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
								:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
								:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
								:total="total">
							</el-pagination>
						</div>
					</div>
					<div class="tableStyleOperation">
						<label style="font-size: 14px; position: absolute;top: -4%;left: 0;">人员负责区域信息</label>
						<el-table :data="tableDataOperation" ref="nbCardInfoTable" style="width: 100%" height="90%"
							v-loading="loading" id="nbRecordTable">
							<el-table-column prop="districtName" label="区域" width="" align="center">
							</el-table-column>
							<el-table-column label="操作" align="center" width="200px">
								<template slot-scope="scope">
									<el-button size="mini" type="primary" class="iconfont"
										@click="removeRegion(scope.row)" icon="el-icon-remove"
										style="background-color: #ed5565 !important;color: white !important;">移出区域
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>

			</div>
		</el-card>
		<el-dialog :title="cardDialogTitle" :visible.sync="cardDialogVisible" width="800px">
			<el-form :model="cardForm" label-width="100px" :rules="cardFormRules">
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="姓名">
							<el-input v-model="cardForm.name" class="searchTag" clearable placeholder="姓名">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号">
							<el-input v-model="cardForm.phone" class="searchTag" clearable placeholder="手机号">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item label="岗位">
							<el-select v-model="cardForm.workPosition" placeholder="" clearable class="searchTag"
								filterable>
								<el-option v-for="item in  workPositionOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cardDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保 存</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="regionDialogTitle" :visible.sync="regionDialogVisible" width="800px">
			<el-form :model="regionForm" label-width="100px" :rules="regionFormRules" ref="regionForm">
				<el-row :gutter="10">
					<el-col :span="24">
						<el-form-item label="区域" prop="districtId">
							<el-cascader v-model="regionForm.districtId" :options="districtIdOptions" :props="props"
								clearable></el-cascader>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="regionDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveRegion">保 存</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		translateObjectEmptyAttributeToNull,
		cascaderAfferentString,
		cascaderAfferentNumber,
		// export_excel_file,
	} from '../../untils/func';
	import exportTable from '../../untils/exportTable';
	import moment from 'moment';
	import {
		selectList,
		save,
		detail,
		remove,
		NbBatchAdd,
		staffDistrictSelectList,
		staffDistrictAdd,
		staffDistrictDelete
	} from '../../api/property/personnelManagement';
	// import { convertExcelDateFormat } from '../../untils/getDate';
	import {
		selectDictionaryListByName,
		selectComboboxTreeData
	} from '../../api/comboboxLoad';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				excelTableColumnName: [

				],
				excelTableColumnProperty: [

				],
				excelTableNotEmptyColumn: [

				],

				excelTableComboboxColumn: [],
				excelTableComboboxColumnTime: [],
				excelTableComboboxColumnValues: [],

				excelTableData: [],
				form: {},
				cardForm: {},
				cardFormRules: {},
				cardDialogVisible: false,
				cardDialogTitle: '',
				// 字典表格数据
				tableData: [],
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
				},
				// 遮罩层
				loading: true,
				total: 0,
				currentRow: null,
				cardTypeOptions: [],
				cardIspOptions: [],
				importExcelDialogVid: false,
				workPositionOptions: [],
				tableDataOperation: [],
				regionDialogTitle: '添加区域',
				regionDialogVisible: false,
				regionForm: {},
				regionFormRules: {
					districtId: [{
						required: true,
						message: '请选择区域',
						trigger: 'change',
					}, ],
				},
				districtIdOptions: [], // 区域 options
				props: {
					expandTrigger: 'hover',
				},
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			// formatDate(row, columnName) {
			//   //日期转换
			//   var date = row[columnName.property];
			//   if (date === undefined || date === null || date === '') {
			//     return null;
			//   }
			//   //非时间格式问题  返回Invalid date
			//   let retFormat = moment(date).format('YYYY-MM-DD');
			//   if (retFormat === 'Invalid date') {
			//     return moment(date).format('YYYY-MM-DD');
			//   }
			//   return  moment(date).add(1,'days').format('YYYY-MM-DD');
			// },
			// 点击模板按钮下载文件
			async downloadTemplate() {
				console.log(111)
				// let res = await getPath({
				// 	name: 'nb卡模板'
				// }).then();
				// let filePath = res.data;
				// if (!filePath) {
				// 	this.$message.error('模板未上传');
				// } else {
				// 	res = await load({
				// 		filePath: filePath
				// 	}).then();
				// 	export_excel_file(res.data, 'nb卡模板', res.headers.fileextend);
				// 	// this.msgSuccess('下载成功');
				// }
			},
			async batchAdd() {
				await NbBatchAdd(this.excelTableData).then();
				this.importExcelDialogVid = false;
				await this.handleQuery();
				this.msgSuccess('导入成功');
			},

			importInExcel(e) {
				let file = e.file; // 文件信息

				if (!file) {
					// 没有文件
					return false;
				} else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
					// 格式根据自己需求定义
					this.$message.error('上传格式不正确，请上传xls或者xlsx格式');
					return false;
				}

				const fileReader = new FileReader();
				fileReader.onload = (ev) => {
					try {
						const data = ev.target.result;
						const workbook = XLSX.read(data, {
							type: 'binary', // 以字符编码的方式解析
							cellDates: true, //设为true，将天数的时间戳转为时间格式
						});
						const exlname = workbook.SheetNames[0]; // 取第一张表
						const exl = XLSX.utils.sheet_to_json(workbook.Sheets[exlname]); // 生成json表格内容

						var i = 0;
						var j = 0;

						//判断必填列
						for (i = 0; i < exl.length; i++) {
							for (let column of this.excelTableNotEmptyColumn) {
								if (exl[i][column] == undefined) {
									this.msgError('第' + (i + 1) + '行' + column + '列不能为空');
									return;
								}
							}
						}

						//判断下拉框列数据是否合法
						for (i = 0; i < exl.length; i++) {
							for (j = 0; j < this.excelTableComboboxColumn.length; j++) {
								var value = exl[i][this.excelTableComboboxColumn[j]];

								if (value != undefined) {
									var flag = false;
									for (let option of this.excelTableComboboxColumnValues[j]) {
										if (option.value == value) {
											flag = true;
											break;
										}
									}

									if (!flag) {
										this.msgError(
											'第' +
											(i + 1) +
											'行' +
											this.excelTableComboboxColumn[j] +
											'列值不合法'
										);
										return;
									}
								}
							}
						}

						//转换成table数据
						for (i = 0; i < exl.length; i++) {
							var rowO = {};
							for (j = 0; j < this.excelTableColumnProperty.length; j++) {
								flag = false;
								var time_flag = false;
								var k = 0;
								for (k = 0; k < this.excelTableComboboxColumn.length; k++) {
									if (
										this.excelTableColumnName[j] ==
										this.excelTableComboboxColumn[k]
									) {
										flag = true;
										break;
									}
								}
								for (
									var t = 0; t < this.excelTableComboboxColumnTime.length; t++
								) {
									if (
										this.excelTableColumnName[j] ==
										this.excelTableComboboxColumnTime[t]
									) {
										time_flag = true;
										break;
									}
								}

								if (flag) {
									for (var option of this.excelTableComboboxColumnValues[k]) {
										if (option.value == exl[i][this.excelTableColumnName[j]]) {
											rowO[this.excelTableColumnProperty[j]] = option.key;
											rowO[this.excelTableColumnProperty[j] + 'Name'] =
												option.value;
											break;
										}
									}
								} else {
									if (time_flag) {
										rowO[this.excelTableColumnProperty[j]] = moment(
												exl[i][this.excelTableColumnName[j]]
											)
											.add(1, 'days')
											.format('YYYY-MM-DD');
										if (
											rowO[this.excelTableColumnProperty[j]] == 'Invalid date'
										) {
											rowO[this.excelTableColumnProperty[j]] =
												exl[i][this.excelTableColumnName[j]];
										}
									} else {
										rowO[this.excelTableColumnProperty[j]] =
											exl[i][this.excelTableColumnName[j]];
									}
								}
							}
							this.excelTableData.push(rowO);
						}
					} catch (e) {
						console.log('出错了：：' + e);
						return false;
					}
				};
				fileReader.readAsBinaryString(file);
			},
			async init() {
				await this.handleQuery();
				await this.getWorkPositionOptions();
				await this.selectComboboxTreeData();
			},
			// 区域下拉框
			async selectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectList(param).then();
				this.tableData = response.data;
				// console.log(this.tableData);
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			cancelChoose() {
				this.$refs.nbCardInfoTable.setCurrentRow();
				this.currentRow = null;
			},
			async removeRegion(row) {
				this.$confirm('确定要删除吗?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(async () => {
					let data = {
						staffId: row.staffId,
						districtId: row.districtId,
					}
					await staffDistrictDelete(data).then();
					await this.staffDistrictSelectList();
					this.msgSuccess('删除成功');
				});
			},
			async addMeter() {
				// 添加卡信息
				this.cardForm = {};
				this.cardDialogTitle = '添加信息';
				this.cardDialogVisible = true;
			},
			async save() {
				await save(this.cardForm).then();
				await this.handleQuery();
				this.msgSuccess('新增成功');
				this.cardDialogVisible = false;
			},
			async editCardInfo() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					await this.viewDetail();
					this.cardDialogTitle = '编辑信息';
					this.cardDialogVisible = true;
				}
			},
			deleteMeter() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.$confirm('确定要删除吗?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(async () => {
						await remove(this.currentRow).then();
						await this.handleQuery();
						this.msgSuccess('删除成功');
					});
				}
			},
			async viewDetail() {
				const res = await detail({
					id: this.currentRow
				}).then();
				this.cardForm = res.data;
			},
			// 单选表格某一行
			async handleCurrentChange(val) {
				this.currentRow = val.id;
				await this.staffDistrictSelectList();
			},
			// 查询区域列表
			async staffDistrictSelectList() {
				let res = await staffDistrictSelectList({
					staffId: this.currentRow
				}).then();
				this.tableDataOperation = res.data;
			},
			async addRegion() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.regionForm = {};
					this.regionDialogTitle = '添加区域';
					this.regionDialogVisible = true;
				}
			},
			async saveRegion() {
				this.$refs.regionForm.validate(async (valid) => {
					if (valid) {
						let param = JSON.parse(JSON.stringify(this.regionForm));
						if (param.districtId == 0) {
							param.districtId = null;
						}
						if (param.districtId != null) {
							if (param.districtId.constructor === Array) {
								param.districtData = cascaderAfferentString(param.districtId);
								param.districtId = cascaderAfferentNumber(param.districtId);
							}
						}
						param.staffId = this.currentRow;
						await staffDistrictAdd(param).then();
						await this.staffDistrictSelectList();
						this.msgSuccess('新增成功');
						this.regionDialogVisible = false;
					} else {
						this.msgError('信息填写错误');
						return false;
					}
				})

			},
			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('nbRecordTable', '人员信息');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			// 获取下拉列表 数据
			async getWorkPositionOptions() {
				//通信卡类型
				const res = await selectDictionaryListByName(
					dictionaryConstant.PROPERTY_STAFF_WORK_POSITION
				).then();
				this.workPositionOptions = res.data;
			},
			// 打开批量导入对话框
			importExcelClick() {
				console.log(111)
				// this.excelTableData = [];
				// this.importExcelDialogVid = true;
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-select {
		width: 100%;
	}

	/deep/ .el-input {
		width: 100%;
	}

	.searchTag {
		width: 200px;
	}

	.searchForm {
		margin-top: 15px;

		.el-form-item {
			display: inline-block;
		}
	}

	.tableBox {
		height: calc(100% - 80px);
		display: flex;
		justify-content: space-between;
	}

	.tableStyle {
		height: 100%;
		width: 60%;
		// background-color: pink;
	}

	.tableStyleOperation {
		height: 100%;
		width: 35%;
		margin-left: 2%;
		position: relative;
	}

	@media screen and (max-width: 1414px) {
		.tableStyle {
			height: calc(100% - 130px);
		}
	}

	.block {
		margin-top: 10px;
	}
</style>
